import {
  deletionBusinessFilterItems,
  customerForecastFilterItems,
  supplierForecastFilterItems,
  inventoryFilterItems,
  orderControlFilterItems,
  orderFilterItems,
  unmanagedBusinessTypeAnnounceFilterItems,
  unmanagedBusinessTypeArrivalFilterItems,
  unmanagedBusinessTypeInventoryFilterItems,
  unmanagedBusinessTypeSalesResultFilterItems,
  orderCalendarFilterItems,
  inventoryDashboardFilterItems,
  inventoryDashboardDetailAggFilterItems,
  inventoryDashboardDetailBaseFilterItems,
  unmatchedOrderFilterItems,
} from './filterItems';
import { FilterContentItem, FilterModalType } from './filterModal';
import { assertNever } from '@/coreDomainsModule/assertNever';

/**
 * フィルターモーダルで使用するViewModel
 */
export class FilterModalViewModel {
  /**
   * モーダルで使用するフィルターアイテムを取得する
   * @param filterModalType - フィルターモーダルのタイプ
   */
  public useFilterItems = (filterModalType: FilterModalType): FilterContentItem[] => {
    switch (filterModalType) {
      case 'customerForecast':
        return [...customerForecastFilterItems];
      case 'supplierForecast':
        return [...supplierForecastFilterItems];
      case 'order':
        return [...orderFilterItems];
      case 'order-calendar':
        return [...orderCalendarFilterItems];
      case 'orderControl':
        return [...orderControlFilterItems];
      case 'inventory':
        return [...inventoryFilterItems];
      case 'deletion-business':
        return [...deletionBusinessFilterItems];
      case 'unmanagedBusinessTypeAnnounce':
        return [...unmanagedBusinessTypeAnnounceFilterItems];
      case 'unmanagedBusinessTypeSalesResult':
        return [...unmanagedBusinessTypeSalesResultFilterItems];
      case 'unmanagedBusinessTypeInventory':
        return [...unmanagedBusinessTypeInventoryFilterItems];
      case 'unmanagedBusinessTypeArrival':
        return [...unmanagedBusinessTypeArrivalFilterItems];
      case 'inventoryDashboard':
        return [...inventoryDashboardFilterItems];
      case 'inventoryDashboardDetailAgg':
        return [...inventoryDashboardDetailAggFilterItems];
      case 'inventoryDashboardDetailBase':
        return [...inventoryDashboardDetailBaseFilterItems];
      case 'unmatchedOrder':
        return [...unmatchedOrderFilterItems];
      default:
        console.error(filterModalType);
        return assertNever(filterModalType);
    }
  };
}
